import View from '@/components/view'

import { RegionProvider } from './contexts/region-context'
import LateralPanel from './lateral-panel'
import { RegionMap } from './region-map'

export default function Maps() {
  return (
    <RegionProvider>
      <View
        variant='default'
        aside={<LateralPanel />}
        overflow
        padding='XS'
        section={<RegionMap />}
      />
    </RegionProvider>
  )
}
